export interface Feature {
  icon: string;
  title: string;
  description: string;
}

export const features: Feature[] = [
  {
    icon: 'ri-cloud-line',
    title: '无需下载',
    description: '所有功能均在云端运行，无需下载安装任何软件或插件，打开浏览器即可使用，节省设备存储空间。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    description: '平台所有工具和服务均免费向用户开放，无隐藏收费，无需订阅会员，真正实现零成本使用。',
  },
  {
    icon: 'ri-device-line',
    title: '多设备支持',
    description: '完美适配电脑、平板、手机等多种设备，无论何时何地都能获得一致流畅的使用体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用先进的加密技术保护用户数据，处理完成后自动清除临时文件，确保隐私安全无虞。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速体验',
    description: '优化的云端架构确保工具运行流畅迅速，秒级响应，让您告别等待，专注高效完成任务。',
  },
  {
    icon: 'ri-global-line',
    title: '随时随地',
    description: '只要有网络连接，就能随时随地访问平台，不受时间和地点限制，真正实现移动办公和娱乐。',
  },
];